import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * @file Created on Thu Jan 21 2021
 * @author Tomáš Leity
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { Inject } from '@logio/typescript-ioc';
import { jsonConversions, PromotionAppConfig, PromotionAppConfigConverter } from '@logio/common-be-fe';
import { CONSTANTS } from '../../../constants';
import logger from '../../logger';
import api from '../../api';
export var PromotionAppConfigLayer =
/*#__PURE__*/
function () {
  function PromotionAppConfigLayer() {
    var _this = this;

    _classCallCheck(this, PromotionAppConfigLayer);

    /**
     * <p>
     *  Load {@link PromotionAppConfig} from specific promotion settings.
     *  Specific use: Load e-commerce config for {@link Promotion} creation page.
     * </p>
     *
     * @returns Promise with {@link PromotionAppConfig} result object.
     */
    this.load = function () {
      var apiConfig = {
        responseType: 'json'
      };
      return api(CONSTANTS.API.ENDPOINTS.PROMOTIONS_CONFIG).get(apiConfig).then(function (response) {
        if (!response.data.result) {
          logger.warn("Missing ".concat(PromotionAppConfig.name, " result response when trying to load the config."));
          return undefined;
        }

        return _this.getConverter().toObject(response.data.result, jsonConversions);
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    };
  }

  _createClass(PromotionAppConfigLayer, [{
    key: "getConverter",
    value: function getConverter() {
      return this.converter;
    }
  }]);

  return PromotionAppConfigLayer;
}();

__decorate([Inject, __metadata("design:type", PromotionAppConfigConverter)], PromotionAppConfigLayer.prototype, "converter", void 0);